import {Image} from "@/types";

export type WhyUsType = {
    id: number;
    title: string;
    description: string;
    image: Image;
}
export const whyUs: WhyUsType[] = [
    {
        id: 1,
        title: 'Fast Next.js Websites',
        description: 'Quick and SEO optimised',
        image: {
            id: 1,
            url: '/images/why-us/why1.svg',
            original: '/images/why-us/why1.svg',
            title: 'fast websites',
        }
    },
    {
        id: 2,
        title: 'Tech Experts',
        description: 'Developers with an edge in SEO',
        image: {
            id: 2,
            url: '/images/why-us/why2.svg',
            original: '/images/why-us/why2.svg',
            title: 'google optimisation',
        }
    },
    {
        id: 3,
        title: 'AI-Driven Marketing',
        description: 'Smarter insights, better results',
        image: {
            id: 3,
            url: '/images/why-us/why3.svg',
            original: '/images/why-us/why3.svg',
            title: 'ai powered marketing',
        }
    },
    {
        id: 4,
        title: 'Scalable Growth Plans',
        description: 'Support as your business grows',
        image: {
            id: 4,
            url: '/images/why-us/why4.svg',
            original: '/images/why-us/why4.svg',
            title: 'seo experts',
        }
    },
    {
        id: 5,
        title: 'No Lock-In Contracts',
        description: 'Flexible plans that fit you',
        image: {
            id: 5,
            url: '/images/why-us/why5.svg',
            original: '/images/why-us/why5.svg',
            title: 'flexible solutions',
        }
    },
    {
        id: 6,
        title: 'Content & Media Ready',
        description: 'Photos, video and social content',
        image: {
            id: 6,
            url: '/images/why-us/why6.svg',
            original: '/images/why-us/why6.svg',
            title: 'media and branding',
        }
    }
];

